import {Component, Input, OnInit} from "@angular/core";
import {isWmAdminNotification, UserNotification} from "@webmate-web-core/shared/types/notification";
import moment from "moment";
import {DateTime} from "@webmate-web-core/shared/types/base-types";
import { NgClass } from "@angular/common";
import {AvatarModule} from "@webmate-web-core/shared/components/avatar/avatar.module";
import {WmCalendarFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-calendar-format';


@Component({
    selector: 'wm-display-notification',
    templateUrl: './display-notification.component.html',
    standalone: true,
    imports: [
        NgClass,
        AvatarModule,
        WmCalendarFormatPipe
    ],
    styleUrls: ['./display-notification.component.less']
})

export class DisplayNotificationComponent {

    @Input() notification: UserNotification;
    @Input() seenDate: DateTime;

    protected readonly moment = moment;
    protected readonly isWmAdminNotification = isWmAdminNotification;

    // Quill's getSemanticHTML() stores every space as &nbsp;, which prevents
    // line wrapping entirely. Restore normal spaces so the text can break at
    // word boundaries; ql-editor's white-space: pre-wrap keeps space runs intact.
    get bodyText(): string {
        return (this.notification?.body?.text ?? '').replace(/&nbsp;/g, ' ');
    }
}
